import { Button, Descriptions, Drawer, Space } from "antd";
import { Eye } from "lucide-react";
import React, { useState } from "react";

const DetailsDrawer = ({ record }) => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button onClick={showDrawer} type="text" icon={<Eye />} />
      <Drawer
  title={`Recapitulatif de la formation`}
  placement="right"
  size={"large"}
  onClose={onClose}
  open={open}
>
  <Descriptions
    bordered
    layout="vertical"
    items={[
      {
        key: "1",
        label: "Nature de la formation - طبيعة التكوين",
        children: record?.data?.training_type_data_nature,
        span: 2,
      },
      {
        key: "2",
        label: "Type - النوع",
        children: record?.data?.training_type_data_type,
        span: 2,
      },
      {
        key: "3",
        label: "Secteur - القطاع",
        children: record?.data?.training_type_data_sector,
        span: 2,
      },
      {
        key: "4",
        label: "Sous-secteur - القطاع الفرعي",
        children: record?.data?.training_type_data_sub_sector,
        span: 2,
      },
      {
        key: "5",
        label: "Spécialité - الإختصاص",
        children: record?.specialite,
        span: 2,
      },
      {
        key: "6",
        label: "Diplôme",
        children: record?.diplome,
        span: 2,
      },
      {
        key: "7",
        label: "Niveau minimum requis - المستوى الادنى المطلوب",
        children: record?.min_niveau_requis?.length === 1 ? record?.min_niveau_requis[0] : record?.min_niveau_requis.map(n => n).join(' OU '),
        span: 2,
      },
      {
        key: "8",
        label: "Mode de formation - نمط التكوين",
        children: record?.data?.training_type_data_mode,
        span: 2,
      },
    ]}
  />
</Drawer>
    </>
  );
};

export default DetailsDrawer;
